import { EnumSchema } from '../metadata-schema';

export const ResultaatBijzonderheid: EnumSchema = {
	"type": "string",
	"title": "ResultaatBijzonderheid",
	"enum": [
		"Telt niet mee",
		"Vrijstelling",
		"Niet gemaakt"
	]
};
